import { useOutletContext } from "react-router-dom";
import { IntegrationShell } from "../common/Shell";

import Messenger from "V2.0/HomePages/HomeIntegrations/Messenger";
import MessengerConnected from "./MessengerConnected";
import { useMessengerConfiguration } from "./useMessengerConfiguration";

export function MessengerIntegration() {
  const { projectId, isViewOnly } = useOutletContext();
  const { messengerConfiguration, fetchMessengerConfiguration } =
    useMessengerConfiguration(projectId);
  const { data, loading, isConfigured } = messengerConfiguration;

  if (loading) {
    return null;
  }

  if (isConfigured) {
    return (
      <IntegrationShell>
        <MessengerConnected
          projectId={projectId}
          messengerConfiguration={data}
          fetchMessengerConfiguration={fetchMessengerConfiguration}
          isViewOnly={isViewOnly}
        />
      </IntegrationShell>
    );
  }

  return (
    <IntegrationShell>
      <Messenger
        projectId={projectId}
        fetchMessengerConfiguration={fetchMessengerConfiguration}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}
